import { useState } from "react";
import { ArrowDown, ArrowUp, ChevronDown } from "lucide-react";
import { Switch } from "../ui/switch";
import FieldEditor from "./FieldEditor";

function SectionCard({ s, index, count, onChange, onMove }) {
  const [open, setOpen] = useState(index === 0);
  return (
    <li className="rounded-lg border border-slate-200 bg-white" data-testid={`cms-section-${s.key}`}>
      <div className="flex items-center gap-3 px-4 py-3">
        <div className="flex flex-col">
          <button type="button" disabled={index === 0} onClick={() => onMove(-1)} aria-label={`Move ${s.label} up`} className="text-slate-500 disabled:opacity-30" data-testid={`cms-section-up-${s.key}`}><ArrowUp size={14} /></button>
          <button type="button" disabled={index === count - 1} onClick={() => onMove(1)} aria-label={`Move ${s.label} down`} className="text-slate-500 disabled:opacity-30" data-testid={`cms-section-down-${s.key}`}><ArrowDown size={14} /></button>
        </div>
        <button type="button" className="flex flex-1 items-center justify-between text-left font-semibold text-navy" onClick={() => setOpen(!open)} aria-expanded={open} data-testid={`cms-section-expand-${s.key}`}>
          {s.label}<ChevronDown size={18} className={`transition-transform duration-200 ${open ? "rotate-180" : ""}`} aria-hidden="true" />
        </button>
        <label className="flex items-center gap-2 text-sm text-slate-600">
          <Switch checked={s.visible} onCheckedChange={(v) => onChange({ ...s, visible: v })} aria-label={`${s.label} visible`} data-testid={`cms-section-toggle-${s.key}`} />
          {s.visible ? "Visible" : "Hidden"}
        </label>
      </div>
      {open && <div className="border-t border-slate-100 p-4"><FieldEditor idPrefix={`sec-${s.key}`} value={s.data} onChange={(d) => onChange({ ...s, data: d })} /></div>}
    </li>
  );
}

export default function PageSectionsEditor({ draft, onChange }) {
  const sections = [...draft.sections].sort((a, b) => a.order - b.order);
  const commit = (list) => onChange({ ...draft, sections: list.map((s, i) => ({ ...s, order: i })) });
  const move = (i, dir) => { const list = [...sections]; [list[i], list[i + dir]] = [list[i + dir], list[i]]; commit(list); };
  return (
    <div>
      <label htmlFor="page-title" className="field-label">Page title</label>
      <input id="page-title" className="field-input mb-5 max-w-md text-sm" value={draft.title} onChange={(e) => onChange({ ...draft, title: e.target.value })} data-testid="cms-page-title-input" />
      <ul className="space-y-3">
        {sections.map((s, i) => (
          <SectionCard key={s.key} s={s} index={i} count={sections.length} onMove={(d) => move(i, d)}
            onChange={(ns) => commit(sections.map((x) => (x.key === s.key ? ns : x)))} />
        ))}
      </ul>
    </div>
  );
}
